import { useMutation } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";

const MUTATION = graphql(`
  mutation deleteCompanySetting($id: ID!) {
    success: deleteCompanySetting(id: $id) {
      message
    }
  }
`);

type Data = ResultOf<typeof MUTATION>;
type Variables = VariablesOf<typeof MUTATION>;


export const useDeleteCompanySettingMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "getSettings",
    });
    cache.evict({
      id: `CompanySetting:${options.variables?.id}`,
    });
    cache.evict({
      fieldName: "searchCompanySettings",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};
